import React from 'react';

import Form from './Form';
import * as ReturnProcessingFee from './ReturnProcessingFee';
import * as UnitRestockingFee from './UnitRestockingFee';
import * as PaymentProcessingFee from './PaymentProcessingFee';

export default function Fees() {
  return (
    <ReturnProcessingFee.Provider>
      <UnitRestockingFee.Provider>
        <PaymentProcessingFee.Provider>
          <Form />
        </PaymentProcessingFee.Provider>
      </UnitRestockingFee.Provider>
    </ReturnProcessingFee.Provider>
  );
}
